import { Formik, Field } from 'formik'
import { Modal, Form } from 'react-bootstrap'
import ReferralCampaignEdit from '../campaignData'
import { useGetRewardDetail } from '../../context/useQuery'
import { useCreateReferralCampaign, useUpdateReferralCampaign } from '../../context/useMutation'
import { useEffect, useState } from 'react'
import { useReferral } from '../../hook'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'

const CampaignModal = ({ isOpen, onClose, refetch, status }) => {
  const intl = useIntl()

  const { mutateAsync: createReferralCampaign, isLoading: createIsLoading } =
    useCreateReferralCampaign()
  const { mutateAsync: updateReferralCampaign, isLoading: updateIsLoading } =
    useUpdateReferralCampaign()
  const { data } = useGetRewardDetail()
  const [section, setSection] = useState(1)
  const {
    type,
    program,
    campaignFilesState,
    deleteFileIdsState,
    uploadFileIdsState,
    selectedGiveAwayProduct,
    selectedGiveAwayProductSet,
    selectedCampaignProduct,
    referralCampaignProductList,
  } = useReferral()

  const createCampaign = async (values: any, products: any, program: any, type: any) => {
    await createReferralCampaign({ values, products, program, type, uploadFileIdsState })
    refetch()
    onClose(false)
  }

  const updateCampaign = async (
    values: any,
    campaignID: string,
    selectedProducts: string[],
    defaultProducts: string[]
  ) => {
    const removedProductsId = defaultProducts.filter(
      (product) => !selectedProducts.includes(product)
    )
    const addedProductsId = selectedProducts.filter((product) => !defaultProducts.includes(product))

    const product = {
      removedProductsId,
      addedProductsId,
    }

    await updateReferralCampaign({
      values,
      campaignID,
      product,
      uploadFileIdsState,
      deleteFileIdsState,
    })
    refetch()
    onClose(false)
  }

  const handleSubmit = (values) => {
    if (values.fixedValue === '' || values.fixedValue <= 0 || values.fixedValue >= 100000) {
      toast.warning(intl.formatMessage({ id: 'CAMPAIGN.ENTER_FIXED_VALUE' }))
      return
    }

    if (!data) {
      const products = selectedCampaignProduct.map((product) => product.id)
      createCampaign(values, products, program, type)
    } else {
      const selectedProducts = selectedCampaignProduct.map((product) => product.id)
      const defaultProducts = referralCampaignProductList.data.map((product) => product.id)
      updateCampaign(values, data.campaign.id, selectedProducts, defaultProducts)
    }
  }

  useEffect(() => {
    if (!data) return

    if (data.result.isSuccess === false) {
      toast.error(data.result.message)
      onClose()
    }

    if (data && data.campaignPriceClusterList.length > 0) {
      const productList = data.campaignPriceClusterList[0].productList
      selectedGiveAwayProductSet(productList)
    }
  }, [data])

  // if (!data || !data.campaign) return null
  const formikData = data
    ? {
      title: data.campaign.name,
      promoCluster: data.campaign.promoCluster.toString(),
      promoType: data.campaign.promoType.toString(),
      promoGroup: data.campaign.promoGroup.toString(),
      priceCluster: data.campaignPriceClusterList,
      pointsToBeEarned: data.campaignPoint.pointsToBeEarned.toString(),
      amountToBeSpent: data.campaignPoint.amountToBeSpent.toString(),
      campaignType: data.campaignPriceClusterList.length > 0 ? '2' : '1',
      productInSelectionType: data.productInSelectionType.toString(),
      productOutSelectionType: data.productOutSelectionType.toString(),
      fixedValue: data.campaignPoint?.fixedValue.toString(),
    }
    : {
      campaignType: '1',
      discountControlType: '1', //1 Moneraty, 2 Quentitive
      // promoCluster: '11',
      promoCluster: type === 'referringCustomerRewardID' ? '11' : '12',
      promoType: '10',
      promoGroup: '10',
      priceCluster: [],
      productType: '0',
      title:
        type === 'referringCustomerRewardID'
          ? 'Customer Referral Campaign'
          : 'Friend Referral Campaign',
      pointsToBeEarned: '0',
      amountToBeSpent: '0',
      fixedValue: '0',
      productInSelectionType: '1',
      productOutSelectionType: '0',
    }

  return (
    <Modal show={isOpen} onHide={() => onClose(false)} size='xl'>
      <Modal.Body>
        <Formik
          initialValues={formikData}
          enableReinitialize
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({ setFieldValue, values, errors, touched, submitForm }) => {
            return (
              <>
                <ReferralCampaignEdit
                  setFieldValue={setFieldValue}
                  values={values}
                  errors={errors}
                  touched={touched}
                  Form={Form}
                  Field={Field}
                  section={section}
                  setSection={setSection}
                  disabled={data ? true : false}
                />
                {section === 1 && (
                  <div className='modal-footer'>
                    {data ? (
                      <>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            onClose(false)
                          }}
                        >
                          {intl.formatMessage({ id: 'GLOBAL.BUTTON.CLOSE' })}
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            onClose(false)
                          }}
                        >
                          {intl.formatMessage({ id: 'GLOBAL.CANCEL' })}
                        </button>
                        <button
                          onClick={submitForm}
                          className='btn btn-primary'
                          disabled={createIsLoading || updateIsLoading || data}
                        >
                          {createIsLoading || updateIsLoading ? (
                            <>{intl.formatMessage({ id: 'LOADING' })}</>
                          ) : (
                            <>{intl.formatMessage({ id: 'GLOBAL.SAVE' })}</>
                          )}
                        </button>
                      </>
                    )}
                  </div>
                )}
              </>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default CampaignModal
